import { AxiosStatic, AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';

export default class AccountTypeMappingResource extends FBaseService {
  public async getAll() : Promise<Map<string, string>> {
    const response:AxiosResponse = await this.apiClient.get('/api/rcx/config/account-type-mapping');
    const accounttypes: { [key: string]: string } = response.data.data;
    const accounttypeMap:Map<string, string> = new Map<string, string>();

    Object.keys(accounttypes).forEach((key:string) => {
      accounttypeMap.set(key, accounttypes[key]);
    });

    return accounttypeMap;
  }
}
